import { TaxiReservationApiTaxiReservationUpdateRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useTaxiReservationUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiReservationApiTaxiReservationUpdateRequest, config) =>
      appApiClient.taxiReservationApi.taxiReservationUpdate(req, config),
  })
